import {
  NEWLINE,
  RECONTRACT,
  RRP_EQUIPMENT,
  RRP_ACCESSORY,
  CHECK_ELIGIBILITY,
  RESERVE_NUMBER,
  CATALOGUE,
  BUY_ADD_ONS,
  TERMINATE_NUMBER,
  CEASE_ADDONS,
  REPLACE_SIM,
  ACTIVATE_SIM,
  CHANGE_MOBILE_NUMBER,
  NUMBER_PORT,
  NUMBER_SHARE,
  CHANGE_PLAN,
  REPORT_LOST,
  TRANSFER_MOBILE_LINE,
  BUY_E_FORM,
  REFIT_LINE
} from '@/config/common';

export const orderTypeConfig = {
  NEWLINE: {
    pathname: '/order/priceplan',
    ordertype: NEWLINE
  },
  RRP_EQUIPMENT: {
    pathname: '/order/equipment',
    ordertype: RRP_EQUIPMENT
  },
  RRP_ACCESSORY: {
    pathname: '/order/equipment?rrpType=accessory',
    ordertype: RRP_ACCESSORY
  },
  NUMBER_SHARE: {
    pathname: '/numbershare',
    ordertype: NUMBER_SHARE
  },
  BUY_ADD_ONS: {
    pathname: '/buyaddons',
    ordertype: BUY_ADD_ONS
  },
  RECONTRACT: {
    pathname: '/order/contract',
    ordertype: RECONTRACT
  },
  CHANGE_PLAN: {
    pathname: '/changeplan',
    ordertype: CHANGE_PLAN
  },
  RESERVE_NUMBER: {
    pathname: '/reservenumber',
    ordertype: RESERVE_NUMBER
  },
  CEASE_ADDONS: {
    pathname: '/ceaseaddons',
    ordertype: CEASE_ADDONS
  },
  ACTIVATE_SIM: {
    pathname: '/simactivation',
    ordertype: ACTIVATE_SIM
  },
  CATALOGUE: {
    pathname: '/catalogue',
    ordertype: CATALOGUE
  },
  TERMINATE_NUMBER: {
    pathname: '/terminatenumber',
    ordertype: TERMINATE_NUMBER
  },
  CHECK_ELIGIBILITY: {
    pathname: '/checkeligibility',
    ordertype: CHECK_ELIGIBILITY
  },
  REPLACE_SIM: {
    pathname: '/replacesim',
    ordertype: REPLACE_SIM
  },
  CHANGE_MOBILE_NUMBER: {
    pathname: '/changemobilenumber',
    ordertype: CHANGE_MOBILE_NUMBER
  },
  NUMBER_PORT: {
    pathname: '/numberport',
    ordertype: NUMBER_PORT
  },
  TRANSACTION_HISTORY: {
    pathname: '/account/transactionhistory',
    ordertype: 'TRANSACTION_HISTORY'
  },
  REPORT_LOST: {
    pathname: '/reportlost',
    ordertype: REPORT_LOST
  },
  CHANGE_USER: {
    pathname: '/account/changeuserdetails',
    ordertype: 'CHANGE_USER'
  },
  BILLING_ADDRESS: {
    pathname: '/account/billingaccount',
    ordertype: 'BILLING_ADDRESS'
  },
  TRANSFER_MOBILE_LINE: {
    pathname: '/transfermobileline',
    ordertype: TRANSFER_MOBILE_LINE
  },
  SUSPEND_LINE: {
    pathname: '/suspendline',
    ordertype: 'SUSPEND_LINE'
  },
  UNSUSPEND_LINE: {
    pathname: '/unsuspendline',
    ordertype: 'UNSUSPEND_LINE'
  },
  SMART_TEMPLATE: {
    pathname: '/smarttemplate',
    ordertype: 'SMART_TEMPLATE'
  },
  PURCHASE_SMART_TEMPLATE: {
    pathname: '/purchasesmarttemplate',
    ordertype: 'PURCHASE_SMART_TEMPLATE'
  },
  BUY_E_FORM:{
    pathname: '/eform',
    ordertype: BUY_E_FORM
  },
  REFIT_LINE: {
    pathname: '/refitline',
    ordertype: REFIT_LINE
  },
};
